<template>
  <div>
    <img src="../../../assets/img/fullScreen.png" class="fullScreen" @click="toFull" alt="">
    <div class="stu-inner-main">
      <topBanner :title="title"></topBanner>
      <div class="flex">
        <div class="lang-change-con">
          <div class="lang-change">
            <div class="lang" :class="lang === 'cn' ? 'currentLang' : ''" @click="lang = 'cn'">CN</div>
            <div class="lang" :class="lang === 'en' ? 'currentLang' : ''" @click="lang = 'en'">EN</div>
          </div>
        </div>
      </div>
      <div class="before">
        <div class="desc">
          <div class="title">{{ lang === 'cn' ? '【答题说明】' : '【Exam Instructions】'}}</div>
          <div class="text">{{ lang === 'cn' ? desc : descEn }}</div>
        </div>
      </div>
      <div class="btns">
        <!-- <div class="btn btn1" @click="handleToIndex">稍后作答</div> -->
        <!-- <div class="btn btn2" @click="nextFn">开始答题</div> -->
      </div>
    </div>
    <el-dialog
      title="请确认选手信息"
      :visible.sync="userInfoVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="90%" center>
      <img :src="avatar" alt="" class="avatar">
      <el-descriptions :column="isPhone ? 1 : 3">
        <!-- <el-descriptions-item label="头像">
          <img :src="avatar" alt="" class="avatar">
        </el-descriptions-item> -->
        <el-descriptions-item label="姓名">{{ userName }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ gender }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ phone }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ email }}</el-descriptions-item>
        <el-descriptions-item label="证件类型">
          <el-tag size="small">{{ cardType === '1' ? '身份证' : '护照' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="证件号码">{{ idCard }}</el-descriptions-item>
        <el-descriptions-item label="学校所在地">{{ address }}</el-descriptions-item>
        <el-descriptions-item label="学校">{{ school }}</el-descriptions-item>
        <el-descriptions-item label="年级">{{ grade }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <div class="footer-button" @click="userInfoVisible = false">确 认</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import env from '@/http/env'
import topBanner from './topBanner.vue'
export default {
  components: {
    topBanner
  },
  data () {
    return {
      activityType: this.$chnEngStatusCode.activityType,
      season: '2024~2025',
      raceSchedule: 2,
      lang: 'cn',
      genderList: [{ id: '1', label: '女' }, { id: '2', label: '男' }],
      avatar: '',
      gender: '',
      userName: '',
      phone: '',
      email: '',
      idCard: '',
      address: '',
      school: '',
      grade: '',
      cardType: '',
      desc: '',
      descEn: '',
      userInfoVisible: false,
      base: env.baseWebIP,
      title: '',
      isPhone: false,
      timer: null
    }
  },
  created () {
    this.getBasicsUserInfo()
    this.queryTheOnlineQuizForm()
    this.isPhone = window.screen.width < 500
  },
  beforeDestroy () {
    this.stopTimer()
  },
  methods: {
    queryMatchStatus () {
      this.$http.get('formMatch/getProgress', { showLoading: false }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            if (res.data.matchEndType === 2) {
              this.$router.push(`/padSemiResult?formName=${this.title}`)
            } else if (res.data.questionId) {
              this.stopTimer()
              this.nextFn()
            }
          }
        }
      })
    },
    stopTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    queryTheOnlineQuizForm () {
      this.$http.get(`formMatch/queryTheOnlineQuizForm?season=${this.season}&raceSchedule=${this.raceSchedule}&activityType=${this.activityType}`).then(res => {
        if (res.code === 200) {
          this.desc = res.data.formExplain
          this.descEn = res.data.questionExplain
          this.title = res.data.formName
          this.queryMatchStatus()
          this.timer = setInterval(() => {
            this.queryMatchStatus()
          }, 1000)
        }
      })
    },
    getBasicsUserInfo () {
      this.$http.post('user/getBasicsUserInfo').then(res => {
        if (res.code === 200) {
          this.gender = this.genderList.find(item => item.id === res.data.sysUser.sex) ? this.genderList.find(item => item.id === res.data.sysUser.sex).label : ''
          this.userName = res.data.sysUser.userName
          this.avatar = res.data.bareheadedPhoto
          this.phone = res.data.sysUser.phone
          this.email = res.data.sysUser.email
          this.idCard = res.data.sysUser.idCard
          this.cardType = res.data.sysUser.cardType
          this.address = res.data.sysUserInfo.nationality + res.data.sysUserInfo.province + res.data.sysUserInfo.city + res.data.sysUserInfo.area
          this.school = res.data.sysUserInfo.schoolName
          this.grade = this.$userInfo.getGradeData().find(item => item.dictCode === Number(res.data.sysUserInfo.grade)).dictLabel
          this.userInfoVisible = true
        }
      })
    },
    getPageTitle () {
      return this.$route.query.formName
    },
    toFull () {
      this.$xcUtils.toFull()
    },
    nextFn () {
      this.$router.push(`/padSemiQuiz?formName=${this.title}&rs=${this.raceSchedule}&season=${this.season}`)
    }
    // handleToIndex () {
    //   this.$router.push('/stu/index')
    // }
  }
}
</script>
<style scoped lang="less">
.before{
  display: flex;
  align-items: center;
  margin-top: 30px;
  .voice{
    background-color: #fff;
    box-shadow:  0 2px 10px rgba(0, 0, 0, .1);
    width: 240px;
    height: 80px;
    border-radius: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 14px;
    color: #f8bc1b;
    margin-left: 60px;
    margin-right: 50px;
    .img{
      width: 40px;
      height: 40px;
      margin-right: 14px;
      cursor: pointer;
    }
  }
  .desc{
    flex: 1;
    margin-left: 60px;
    margin-right: 60px;
    .title{
      font-size: 18px;
      color: #b81c25;
      margin-bottom: 10px;
    }
    .text{
      font-size: 12px;
      line-height: 24px;
      white-space: pre-line;
      margin-left: 14px;
      height: 240px;
      overflow-y: auto;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  .btn{
    margin: 40px;
    width: 140px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-radius: 36px;
    cursor: pointer;
    &:active{
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.5);
    }
    &.btn1{
      background-color: #352b28;
    }
    &.btn2{
      background-color: #B81c25;
    }
  }
}

.avatar{
  width: auto;
  height: 100px;
  margin: 0 auto 20px;
  display: block;
}

.lang-change{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 auto;
  padding-right: 42px;
  .lang{
    width: 60px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    background-color: #000;
    border-radius: 20px;
    cursor: pointer;
    margin-left: 10px;
    &.currentLang{
      background-color: #b81c25;
    }
  }
}
.flex{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.stu-inner-main{
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #d8d8d8;
  background-image: url(../../../assets/img/stu-page-bg.png);
  background-size: 100% auto;
  background-position: left bottom;
  background-repeat: no-repeat;
}
.fullScreen{
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 30px;
  height: 30px;
}
*{
  -webkit-tap-highlight-color: transparent;
}

@media screen and (max-width: 500px) {
  /* 在这里应用适合小屏幕设备的样式 */
  .before .desc .text{
    height: auto;
  }
}
.footer-button{
  background-color: #b81c25;
  width: 180px;
  height: 40px;
  border-radius: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  margin: 0 auto 20px;
}
</style>
